import { pendulumRenderer } from './pendulum.js';
import { collisionRenderer } from './collision.js';
import { inclineRenderer } from './incline.js';
import { circularRenderer } from './circular.js';

export const renderers = {
  pendulum: pendulumRenderer,
  collision: collisionRenderer,
  incline: inclineRenderer,
  circular: circularRenderer,
};

export function getRenderer(id) {
  return renderers[id] ?? pendulumRenderer;
}
